<atx-infinite-scroll (scrolled)="onScroll()">
  @if ((searchData$ | async)?.items; as items) { @for (item of items; track
  trackByUserId($index, item)) {
  <atx-accordion class="pt-2" data-e2e="basket-selector-user">
    <atx-accordion-panel
      [panelId]="item.user.id"
      [open]="isOpened(item.user.id)"
      (toggled)="handleToggled($event)"
      [content]="accordionContentRef"
    >
      <atx-accordion-header class="cursor-pointer">
        <div class="d-flex align-items-center px-3 pb-3">
          <fa-icon
            class="mr-2"
            [icon]="['fas', 'angle-down']"
            [rotate]="isOpened(item.user.id) ? null : 270"
          ></fa-icon>
          <atx-avatar
            size="s"
            [image]="item.user?.profilePictureUrl"
            [fullName]="item.user?.displayName"
          ></atx-avatar>
          <span class="max-size ml-2">{{ item.user?.displayName }}</span>
        </div>
      </atx-accordion-header>
    </atx-accordion-panel>
    <ng-template #accordionContentRef>
      @for (basket of item?.baskets; track trackByBasketId($index, basket)) {
      <epc-basket-selector
        [basket]="basket"
        [isActive]="isActive(basket.id)"
      ></epc-basket-selector>
      }
    </ng-template>
  </atx-accordion>
  } }
</atx-infinite-scroll>
